<div
  class="jeopary-select-country"
  style="text-align: -webkit-center"
  [@fadeInOnEnter]="{ value: '', params: { duration: fadeInDuration } }"
  [@fadeOutOnLeave]="{ value: '', params: { duration: fadeOutDuration } }"
>
  <!-- (mouseup)="onPointerUp($event)"
  (touchend)="onPointerUp($event, null)" -->
  <h2>{{ i18n.str("challengeu.user_choose_avatar", "Choose an avatar")() }}</h2>
  <jeopardy-avatar-carousel (avatarSelectedUpdate)="avatarSelected.set($event)">
  </jeopardy-avatar-carousel>

  <div style="margin-bottom: 3em">
    <h2>
      {{
        i18n.str("challengeu.user_your_first_name", "And your first name is:")()
      }}
    </h2>
    <input
      type="text"
      placeholder="{{ usernamePlaceholder }}"
      [(ngModel)]="username"
      [ngModelOptions]="{ standalone: true }"
      (blur)="
        usernamePlaceholder = i18n.str(
          'challengeu.user_what_first_name',
          'What is your first name?'
        )()
      "
      (focus)="usernamePlaceholder = ''"
    />
  </div>
  @if (profileExists) {
  <div>
    {{
      i18n.str(
        "challengeu.user_profile_exists",
        "There is already a profile with the name ad country you provided."
      )()
    }}
  </div>
  }

  <div class="checkbox" style="margin-bottom: 2.5em">
    <input
      type="checkbox"
      id="terms-conditions"
      [(ngModel)]="agreeTerms"
      [ngModelOptions]="{ standalone: true }"
    />
    <label for="terms-conditions" (click)="toggleAgreeTerms($event)">
      {{ i18n.str("challengeu.user_i_agree", "I agree with")() }}
      <a
        href="#"
        title="{{
          i18n.str(
            'challengeu.terms_conditions_title',
            'Terms and conditions'
          )()
        }}"
        (click)="showTermsAndConditions($event)"
        (touchend)="showTermsAndConditions($event)"
      >
        {{
          i18n.str(
            "challengeu.terms_conditions_title",
            "Terms and conditions"
          )()
        }}
      </a>
    </label>
  </div>

  <p
    class="jeopardy-button primary"
    [class.disabled]="!username || !agreeTerms"
  >
    <a href="#" (click)="confirmSelection($event)">{{
      i18n.str("challengeu.dialog_ok", "OK")()
    }}</a>
  </p>
</div>
